import React, { useState } from 'react'

const MonthlyPerfDataContext = React.createContext(null)

export const MonthlyPerfDataProvider = ({ children }) => {
  const [allData, setAllData] = useState({})
  const [currentData, setCurrentData] = useState({})
  const [nonEditDataMap, setNonEditDataMap] = useState({})
  const [meterData, setMeterDataList] = useState([])
  const [md, setMd] = useState({})
  const [activeTab, setActiveTab] = useState('')
  const [dataError, setDataError] = useState([])

  const dataMd = meterData =>
    (meterData || [])
      .filter(f => (f.meterId || '').endsWith('SHARE'))
      .map(m => ({ [m.unit + m.unitName]: m }))
      .reduce((a, b) => ({ ...a, ...b }), {})

  const setMeterData = data => {
    setMeterDataList(data)
    const conMD = dataMd(data)
    setMd(conMD)
  }

  const revertMDData = _ => setMd(dataMd(meterData))

  return (
    <MonthlyPerfDataContext.Provider
      value={{
        setAllData,
        allData,
        currentData,
        setCurrentData,
        activeTab,
        setActiveTab,
        nonEditDataMap,
        setNonEditDataMap,
        dataError,
        setDataError,
        meterData,
        setMeterData,
        md,
        setMd,
        revertMDData,
      }}
    >
      {children}
    </MonthlyPerfDataContext.Provider>
  )
}

export default MonthlyPerfDataContext
